/**
 * Material 3 elevation ramp — shadow values used by overlays, popovers, cards,
 * toasts and modals. Mirrors the `--elev-*` custom properties in the design
 * handoff, so styled-components can read theme.elevation.* and the same
 * shapes show up consistently across the Processes design system.
 *
 * Two ramps live here so consumers can pick the right one for the current
 * theme: `dark` is denser/blacker (matches the canonical dark surface) and
 * `light` is bluer/softer so cards lift cleanly on a near-white background.
 */
export const elevationDark = {
  level1: '0 1px 2px 0 rgb(0 0 0 / 0.30)',
  level2: '0 1px 2px 0 rgb(0 0 0 / 0.30), 0 2px 6px 2px rgb(0 0 0 / 0.15)',
  level3: '0 4px 8px 3px rgb(0 0 0 / 0.15), 0 1px 3px 0 rgb(0 0 0 / 0.30)',
  modal: '0 24px 60px rgb(0 0 0 / 0.45), 0 8px 24px rgb(0 0 0 / 0.35)',
};

export const elevationLight = {
  level1: '0 1px 2px 0 rgb(20 20 50 / 0.08)',
  level2: '0 1px 2px 0 rgb(20 20 50 / 0.08), 0 4px 12px 0 rgb(20 20 50 / 0.10)',
  level3: '0 4px 12px 0 rgb(20 20 50 / 0.10), 0 12px 28px 0 rgb(20 20 50 / 0.10)',
  modal: '0 24px 60px rgb(20 20 50 / 0.18), 0 8px 24px rgb(20 20 50 / 0.12)',
};

export default elevationDark;
